// Empty grade form template
export const emptyGradeForm = {
  name: '',
  classification: 'SkateNZ',
  judging_system: 'RollArt',  // 'RollArt' | 'White System'
  group_by_grade: false,
  is_beginner_for_fees: false,
  b_mark_no_rollart: false,
  local_regional_only: false,
  skate_mf_together: false,
  judge_mf_together: false,
  can_use_panels: false,
  round_one_content_type: '',
  round_two_content_type: 'No Round Two',
  judges_notes_round_one: '',
  judges_notes_round_two: '',
  include_judges_notes_in_schedule: false,
  num_groups: null,
  circuits_per_figure: '2 per figure',
  group_1: { figure_1_id: '', figure_1_foot: '', figure_2_id: '', figure_2_foot: '', figure_3_id: '', figure_3_foot: '', figure_4_id: '', figure_4_foot: '' },
  group_2: { figure_1_id: '', figure_1_foot: '', figure_2_id: '', figure_2_foot: '', figure_3_id: '', figure_3_foot: '', figure_4_id: '', figure_4_foot: '' },
  group_3: { figure_1_id: '', figure_1_foot: '', figure_2_id: '', figure_2_foot: '', figure_3_id: '', figure_3_foot: '', figure_4_id: '', figure_4_foot: '' },
  group_4: { figure_1_id: '', figure_1_foot: '', figure_2_id: '', figure_2_foot: '', figure_3_id: '', figure_3_foot: '', figure_4_id: '', figure_4_foot: '' },
  dance_1_id: '',
  dance_2_id: '',
  // Programme timing fields for Round 1
  round_one_timing_type: 'maximum',
  round_one_add_margin: false,
  round_one_time_min: '',
  round_one_time_max: '',
  round_one_margin: '',
  round_one_styledance_id: '',
  // Programme timing fields for Round 2
  round_two_timing_type: 'maximum',
  round_two_add_margin: false,
  round_two_time_min: '',
  round_two_time_max: '',
  round_two_margin: '',
  round_two_styledance_id: '',
  // Team-size constraints (Team grades only). Reserves don't count
  // toward min/max skaters. ``max_reserves`` is its own cap (e.g.
  // Quartets allow 1, Precision allows 4).
  min_skaters: 4,
  max_skaters: '',
  max_reserves: ''
};

export const roundOneContentTypes = [
  'Groups', 'Compulsories', 'Programme', 'Short Programme', 'Styledance', 'Freedance', 'Competition Specific Event'
];

export const roundTwoContentTypes = ['No Round Two', 'Long Programme', 'Freedance'];

// Public user-facing label — Feb 2026 owner spec renames the "Other"
// classification to "Local/Regional" in all headings. The stored value
// stays ``"Other"`` to avoid a schema migration on a live system.
export const classificationLabel = (c) => (c === 'Other' ? 'Local/Regional' : c);
export const classifications = ['WorldSkate', 'Oceania', 'SkateNZ', 'Other'];

// Programme content types that require timing configuration
export const programmeContentTypes = ['Programme', 'Short Programme', 'Styledance', 'Freedance', 'Long Programme'];

// Generate time options for dropdowns (0:00 to specified max)
export const generateTimeOptions = (maxMinutes, maxSeconds = 55) => {
  const options = [];
  for (let min = 0; min <= maxMinutes; min++) {
    const maxSec = min === maxMinutes ? maxSeconds : 55;
    for (let sec = 0; sec <= maxSec; sec += 5) {
      const value = `${min}:${sec.toString().padStart(2, '0')}`;
      options.push(value);
    }
  }
  return options;
};

export const startTimeOptions = generateTimeOptions(5, 55); // 0:00 to 5:55
export const endTimeOptions = generateTimeOptions(6, 0);    // 0:00 to 6:00
export const marginOptions = ['5s', '10s'];
